// removed by extract-text-webpack-plugin
module.exports = {"DateControlView_Checkbox":"DateControlView_Checkbox__2pxJm0R79ejG","link":"link__1PWycyku1T5u"};